import React from "react";

const AmExSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="American Express"
    >
      <g clipPath="url(#clip0_3693_1095)">
        <g clipPath="url(#clip1_3693_1095)">
          <path
            d="M21.912 14.2507L20.8027 13.0133L19.6507 14.2507H17.3893H12.5253V8.49067H10.264L13.08 2.048H15.8107L16.792 4.26667V2.048H20.2053L20.8027 3.712L21.4 2.048H24.0027V1.06667C24.0027 0.469333 23.5333 0 22.936 0H0.0666666C-0.530667 0 -1 0.469333 -1 1.06667V14.9333C-1 15.5307 -0.530667 16 0.0666666 16H22.936C23.5333 16 24.0027 15.5307 24.0027 14.9333V14.2507H21.912Z"
            fill="#0071CE"
          />
          <path
            d="M22.2107 13.568H24.0027L21.656 11.0507L24.0027 8.57599H22.2533L20.76 10.1973L19.3093 8.57599H17.5173L19.9067 11.0933L17.5173 13.568H19.2667L20.76 11.9467L22.2107 13.568Z"
            fill="#0071CE"
          />
          <path
            d="M14.6585 12.416V11.648H17.4745V10.496H14.6585V9.72799H17.5172V8.57599H13.2932V13.568H17.5172V12.416H14.6585Z"
            fill="#0071CE"
          />
          <path
            d="M22.68 7.85065H23.96V2.81598L21.912 2.85865L20.8027 5.97331L19.6507 2.85865H17.5173V7.85065H18.8827V4.35198L20.1627 7.85065H21.3573L22.68 4.35198V7.85065Z"
            fill="#0071CE"
          />
          <path
            d="M15.3413 2.85864H13.592L11.3733 7.85064H12.8666L13.2933 6.86931H15.5973L16.024 7.85064H17.56L15.3413 2.85864ZM13.7626 5.71731L14.4453 4.09598L15.128 5.71731H13.7626Z"
            fill="#0071CE"
          />
          <path
            d="M22.7653 10.9226L24.0026 12.288V9.55731L22.7653 10.9226Z"
            fill="#0071CE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3693_1095">
          <rect width="24" height="16" rx="1" fill="white" />
        </clipPath>
        <clipPath id="clip1_3693_1095">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AmExSmallIcon;
